module.exports = __webpack_public_path__ + "r-v3/img/speaker_media_on_white.acdcd4df.svg";